import { render, staticRenderFns } from "./premiseModal.vue?vue&type=template&id=c0b14582&"
import script from "./premiseModal.vue?vue&type=script&lang=js&"
export * from "./premiseModal.vue?vue&type=script&lang=js&"
import style0 from "./premiseModal.vue?vue&type=style&index=0&id=c0b14582&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b14582')) {
      api.createRecord('c0b14582', component.options)
    } else {
      api.reload('c0b14582', component.options)
    }
    module.hot.accept("./premiseModal.vue?vue&type=template&id=c0b14582&", function () {
      api.rerender('c0b14582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Premises/premiseModal.vue"
export default component.exports